import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Edit01 = function Edit01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M2.876 18.1156c.046-.4135.069-.6202.1315-.8134a2 2 0 0 1 .2331-.4851c.1118-.1696.259-.3166.5531-.6108L17 3c1.1046-1.1046 2.8954-1.1046 4 0s1.1046 2.8954 0 4L7.7937 20.2063c-.2942.2942-.4413.4412-.6108.5531a2 2 0 0 1-.485.2331c-.1933.0625-.4.0855-.8136.1315L2.5 21.5z"
    })
  }));
};
export default Edit01;